import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { DEFAULT_PRODUCTS_PAGE_URL } from '../../../services/user-permission-service';
import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ProductsPage',
    defaultMessage: 'Products',
    id: 'EfaURg',
  },
});

export const hotkey = ['g', 'p'];
export const barcodeContent = '+9FDY893N868T=';

const GotoProductsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push(DEFAULT_PRODUCTS_PAGE_URL), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gp'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoProductsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoProductsPage;
